module.exports = __webpack_public_path__ + "static/media/video.de9fed2e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/ContactUs/video.mp4
// module id = 223
// module chunks = 0